import React from 'react'
import { Button } from "reactstrap";

const SelectedPackageDelete = ({deleteSelected, setIsAllDeleteModalVisible}) => {
    return (
		<div>
			<p>Do you want to delete selected items</p>
			<div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
				<Button color="info" onClick={deleteSelected}>
					Yes
				</Button>
				<Button onClick={() => setIsAllDeleteModalVisible(false)}>No</Button>
			</div>
		</div>
	);
}

export default SelectedPackageDelete
